module.exports = __webpack_public_path__ + "static/media/card4_2@2x.84c67629.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/card4_2@2x.png
// module id = 1716
// module chunks = 0